import { CfAsset } from '../asset';

export function mapCfEntityToCfUspCard(cfEntity = {}) {
    const { fields } = cfEntity;
    const { description, name, title, icon } = fields || {};

    return {
        description,
        name,
        title,
        icon: icon && CfAsset.mapCfEntity(icon),
    };
}
